import { Link } from 'react-router-dom'
import { EmptyState } from '@/shared/components/EmptyState'
import { Tooltip } from '@/shared/components/Tooltip'
import type { ProviderModuleRef } from '@/lib/apiTypes'
import { ConstraintCell } from '@/features/providers/components/ConstraintCell'

/** Module references tab: which modules' required_providers admit this version (declared, not
 *  necessarily deployed - the Live usage tab is the deployed truth). Each module links to its
 *  detail page (navigating unmounts this modal - URL-driven, so back returns here). */
export function VersionRefsPanel({ orgId, refs }: { orgId: string; refs: ProviderModuleRef[] }) {
  if (refs.length === 0) {
    return <EmptyState icon="⬡" title="Not referenced by any module" subtitle="No module's required_providers declares this provider at a constraint admitting this version." />
  }
  return (
    <div className="table-wrap table-scroll" style={{ maxHeight: 300 }}>
      <table>
        <thead>
          <tr>
            <th>
              <Tooltip text="Module whose required_providers declares this provider." placement="top">
                <span tabIndex={0} className="cursor-help">Module</span>
              </Tooltip>
            </th>
            <th>
              <Tooltip text="The version range that module declares - this version satisfies it." placement="top">
                <span tabIndex={0} className="cursor-help">Constraint</span>
              </Tooltip>
            </th>
          </tr>
        </thead>
        <tbody>
          {refs.map((r, i) => (
            <tr key={`${r.module_id}-${i}`}>
              <td style={{ fontSize: '0.82rem' }}>
                {r.module_provider ? (
                  <Link to={`/org/${orgId}/modules/${encodeURIComponent(r.module_name)}/${encodeURIComponent(r.module_provider)}`}>
                    {r.module_name}
                  </Link>
                ) : (
                  // Older worker payloads (pre module_provider) can't form the URL - plain text.
                  r.module_name
                )}
              </td>
              <td><ConstraintCell value={r.version_constraint} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
